export enum TrackingChannel {
  HelpCenter = 'help_center',
  Transaction = 'transaction',
  Search = 'search',
  Conversation = 'conversation',
}
